import React from 'react'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import Tooltip from 'components_new/atoms/Tooltip'

import { DashboardStatus } from 'types/GlobalDashboardGroup'
import { TDashboardGroup } from 'types/GlobalDashboardGroup'

interface TopbarContentProps {
  dashboardGroup: TDashboardGroup | null
  onOpenAboutDialog: () => void
  onToggleFavorite: () => void
}

const TopbarContent = (props: TopbarContentProps) => {
  const { dashboardGroup, onOpenAboutDialog, onToggleFavorite } = props

  const { t } = useTranslation()

  if (!dashboardGroup) return null

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip
        title={
          dashboardGroup.status !== DashboardStatus.PUBLISHED
            ? t('dashboards', 'favorite_unpublished_tooltip')
            : dashboardGroup.favorite
              ? t('dashboards', 'remove_favorite_tooltip')
              : t('dashboards', 'add_favorite_tooltip')
        }
      >
        <Box>
          <IconButton
            onClick={onToggleFavorite}
            size="small"
            disabled={dashboardGroup.status !== DashboardStatus.PUBLISHED}
          >
            <Icon
              fontSize="small"
              name={
                dashboardGroup.favorite ? 'StarOutlined' : 'StarBorderOutlined'
              }
              color={dashboardGroup.favorite ? 'primary' : 'inherit'}
            />
          </IconButton>
        </Box>
      </Tooltip>

      <Tooltip title={t('dashboards', 'show_info')}>
        <IconButton onClick={onOpenAboutDialog} size="small">
          <Icon fontSize="small" name="Info" />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default TopbarContent
